import React from "react";
import { I_AllDataNeeded } from "../Models/interfaces";

export const AllDataNeededContext = React.createContext<I_AllDataNeeded>({
  teacherId: "",
  teacherName: "",
  subjectId: "",
  lessonId: "",
  lessonName: "",
  sectionName: "",
  lessonPictureUrl: "",
});

export const SetAllDataNeededContext = React.createContext<
  React.Dispatch<React.SetStateAction<I_AllDataNeeded>>
>(() => {});
